import React from "react";

export function ProductSection() {
  const productDescription =
    "Fourteen double-sized 4 oz bottles are available from Liquid Stretch First Light Harvest, the launch special.";

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-8 items-center">
          <div className="relative aspect-[4/3] rounded-lg overflow-hidden">
            <img
              src="/images/liquid-stretch-v2-bottle-mockup.png"
              alt="Liquid Stretch Product"
              className="object-cover w-full h-full"
            />
          </div>
          <div className="space-y-6">
            <h2 className="text-3xl font-bold">Liquid Stretch | Limited Run Hemp Oil</h2>
            <p className="text-lg text-gray-700">
              First Light Harvest, the double-sized 4 oz launch special, is available now for $90.
            </p>
            <p className="text-lg text-gray-700">
              Golden Hour Harvest is the planned next 2 oz formulation, with about 58 servings and a 3:1 CBD-to-THC balance.
              Join the next-batch list and we will email you when pre-orders are ready to open.
            </p>
            <div className="space-y-4">
              <p className="text-xl font-semibold">14 First Light Harvest bottles available</p>
              <button
                className="snipcart-add-item inline-flex w-full items-center justify-center rounded-lg bg-[#d69b13] px-8 py-3 text-lg font-bold text-[#150f04] transition-colors hover:bg-[#f0c766] md:w-auto"
                data-item-id="1"
                data-item-name="Liquid Stretch First Light Harvest"
                data-item-price="90.00"
                data-item-url="/api/products/1.json"
                data-item-description={productDescription}
                data-item-image="/images/liquid-stretch-v2-bottle-mockup.png"
                data-item-categories="4 oz. Launch Special"
                data-item-has-taxes-included="true"
                data-item-max-quantity="14"
                data-item-shippable="true"
                type="button"
              >
                Purchase First Light Harvest — $90
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
} 
